import { useTranslation, useUrlParam } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Card, Flex, Tag, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { Project } from "../../../../../js/parsegenerated";
import { useProject } from "../../hooks/useProject";
import { ProjectDuedateIcon } from "./ProjectDuedateIcon";

type Props = {
  project: Project;
  style?: React.CSSProperties;
};

export const SubProjectItem = observer((props: Props) => {
  const t = useTranslation();
  const { project: parent } = useProject(); // parent from context
  const { color, colorText, project, icon } = useProject(props.project); // project from props with color and color text for presentation
  const [_, setActiveSubProject] = useUrlParam(parent.id, undefined);

  return (
    <Card variant="outlined" size="small" styles={{ body: props.style }}>
      <Flex align="center" gap="small">
        <Tooltip title={t("maintenance:project.navigate.single")}>
          <Tag
            color={color}
            style={{ margin: 0, cursor: "pointer", color: colorText }}
          >
            <Flex align="center" gap="small">
              <Icon icon={icon} />
              {project.get("name")}
              <ProjectDuedateIcon project={project} />
            </Flex>
          </Tag>
        </Tooltip>
        <div style={{ marginLeft: "auto" }} /> {/* spacer */}
        <Tooltip title={t("maintenance:project.navigate.sub")}>
          <Icon
            icon="fa:chevron-right"
            onClick={() => setActiveSubProject(project.id)}
            style={{ cursor: "pointer" }}
          />
        </Tooltip>
      </Flex>
    </Card>
  );
});
